import { NavLink, Outlet } from 'react-router-dom';
import { cx, useAuth } from '@mobi/web';

const TABS = [
  { to: '/fila', label: 'Fila' },
  { to: '/ao-vivo', label: 'Ao vivo' },
  { to: '/historico', label: 'Histórico' },
  { to: '/usuarios', label: 'Usuários' },
  { to: '/financeiro', label: 'Financeiro' },
  { to: '/auditoria', label: 'Auditoria' },
];

export function Shell() {
  const { user, logout } = useAuth();

  return (
    <div className="flex h-app flex-col bg-surface">
      <header className="border-b border-line px-5 py-3">
        <div className="mx-auto flex max-w-6xl items-center justify-between">
          <div className="flex items-center gap-6">
            <img src="/brand-wordmark.png?v=1" alt="WiGo" className="h-6 w-auto" />
            <nav className="hidden gap-1 sm:flex">
              {TABS.map((tab) => (
                <NavLink
                  key={tab.to}
                  to={tab.to}
                  className={({ isActive }) =>
                    cx(
                      'rounded-xl px-3 py-2 text-sm font-medium transition',
                      isActive ? 'bg-brand/15 text-brand' : 'text-muted hover:bg-surface-2',
                    )
                  }
                >
                  {tab.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden text-sm text-muted sm:inline">{user?.name}</span>
            <button
              type="button"
              onClick={() => void logout()}
              className="text-sm font-medium text-muted underline underline-offset-4 hover:text-ink"
            >
              Sair
            </button>
          </div>
        </div>
      </header>

      <nav className="flex gap-1 overflow-x-auto border-b border-line px-3 py-2 sm:hidden">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              cx(
                'shrink-0 rounded-xl px-3 py-2 text-sm font-medium transition',
                isActive ? 'bg-brand/15 text-brand' : 'text-muted',
              )
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <main className="min-h-0 flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
